import { toast } from "react-toastify";
import FuseUtils from "@fuse/utils/FuseUtils";
import axios from "axios";
import jwtDecode from "jwt-decode";
/* eslint-disable camelcase */

let baseUrl = process.env.REACT_APP_API_KEY;
// let baseUrl = "http://localhost:8074/api/";

class LoginService extends FuseUtils.EventEmitter {
	init() {
		this.setInterceptors();
		this.handleAuthentication();
	}

	setInterceptors = () => {
		axios.interceptors.response.use(
			(response) => {
				return response;
			},
			(err) => {
				return new Promise((resolve, reject) => {
					if (
						err.response.status === 401 &&
						err.config &&
						!err.config.__isRetryRequest
					) {
						// if you ever get an unauthorized response, logout the user
						this.emit("onAutoLogout", "Invalid access_token");
						this.setSession(null);
					}
					throw err;
				});
			}
		);
	};

	handleAuthentication = () => {
		const access_token = this.getAccessToken();

		if (!access_token) {
			this.emit("onNoAccessToken");

			return;
		}

		if (this.isAuthTokenValid(access_token)) {
			this.setSession(access_token);
			this.emit("onAutoLogin", true);
		} else {
			this.setSession(null);
			this.emit("onAutoLogout", "access_token expired");
		}
	};

	createUser = (data) => {
		return new Promise((resolve, reject) => {
			axios.post("/api/auth/register", data).then((response) => {
				if (response.data.user) {
					this.setSession(response.data.access_token);
					resolve(response.data.user);
				} else {
					reject(response.data.error);
				}
			});
		});
	};

	signInWithEmailAndPassword = (email, password) => {
		let data = {
			username: email,
			password: password,
		};
		return new Promise((resolve, reject) => {
			axios
				.post(baseUrl + "login", data)
				.then((response) => {
					if (response.data.data) {
						this.setSession(response.data.data.authToken);
						resolve(response.data.data);
					} else {
						reject(response.data.error);
					}
					// toast.success("Login Successfully");
				})
				.catch((error) => {
					toast.error(
						error &&
							error.response &&
							error.response.data &&
							error.response.data.message &&
							error.response.data.message
					);
				});
		});
	};

	signInWithToken = () => {
		return new Promise((resolve, reject) => {
			axios
				.get("/api/auth/access-token", {
					data: {
						access_token: this.getAccessToken(),
					},
				})
				.then((response) => {
					if (response.data.user) {
						this.setSession(response.data.access_token);
						resolve(response.data.user);
					} else {
						this.logout();
						Promise.reject(new Error("Failed to login with token."));
					}
				})
				.catch((error) => {
					this.logout();
					Promise.reject(new Error("Failed to login with token."));
				});
		});
	};

	updateUserData = (user) => {
		return axios.post("/api/auth/user/update", {
			user,
		});
	};

	setSession = (access_token) => {
		if (access_token) {
			localStorage.setItem("access_token", access_token);
			axios.defaults.headers.common.Authorization = `Bearer ${access_token}`;
		} else {
			localStorage.removeItem("access_token");
			localStorage.removeItem("userData");
			delete axios.defaults.headers.common.Authorization;
		}
	};

	logout = () => {
		this.setSession(null);
	};

	isAuthTokenValid = (access_token) => {
		if (!access_token) {
			return false;
		}
		const decoded = jwtDecode(access_token);
		const currentTime = Date.now() / 1000;
		if (decoded.exp < currentTime) {
			console.warn("access token expired");
			return false;
		}

		return true;
	};

	getAccessToken = () => {
		return window.localStorage.getItem("access_token");
	};
}

const instance = new LoginService();

export default instance;
